import cn from 'classnames';
import styles from './SizesTable.module.scss';
import { SizesTableType } from '@/types';
import { Modal } from '@/atoms/Modal';
import { BottomDrawer } from '@/atoms/BottomDrawer';
import { ModalContentWrapper } from '@/atoms/ModalContentWrapper';
import { useAdaptiveLayout } from '@/hooks/useAdaptiveLayout';
import { parseText } from '@/utils/parseText';
import { useBodyScrollLock } from '@/hooks/useBodyScrollLock';

type SizesTableProps = {
  data: SizesTableType;
  className?: string;
  active: boolean;
  onClose: () => void;
};

type TableCellProps = {
  text: string;
  isTitle?: boolean;
};

type TableRowProps = {
  row: string[];
};

export function SizesTable({
  data,
  className,
  active,
  onClose,
}: SizesTableProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const { isTablet } = useAdaptiveLayout();
  useBodyScrollLock(active);

  if (!data.header || !data.row) {
    return null;
  }

  const drawerContent = (
    <div className={wrapperClassName}>
      <ModalContentWrapper title="Таблица размеров" onClose={onClose}>
        <div className={styles.table}>
          <div className={styles.heading}>
            {data.header.map((item, index) => (
              <TableHeadingCell key={index} text={item} isTitle={index === 0} />
            ))}
          </div>
          <div className={styles.rows}>
            {data.row.map((row, rowIndex) => (
              <TableRow key={rowIndex} row={row} />
            ))}
          </div>
        </div>
        {data.description && (
          <div className={styles.description}>
            {parseText(data.description)}
          </div>
        )}
      </ModalContentWrapper>
    </div>
  );

  if (!active) return null;

  return (
    <>
      <Modal active={!isTablet} onClose={onClose} showCloseButton>
        {drawerContent}
      </Modal>
      <BottomDrawer active={!!isTablet} onClose={onClose}>
        {drawerContent}
      </BottomDrawer>
    </>
  );
}

function TableHeadingCell({ text, isTitle }: TableCellProps) {
  return (
    <span
      className={cn(styles.headingCell, {
        [styles.headingCellTitle]: isTitle,
      })}
    >
      {parseText(text)}
    </span>
  );
}

function TableCell({ text, isTitle }: TableCellProps) {
  return (
    <span
      className={cn(styles.rowCell, {
        [styles.rowCellTitle]: isTitle,
      })}
    >
      {parseText(text)}
    </span>
  );
}

function TableRow({ row }: TableRowProps) {
  return (
    <div className={styles.row}>
      {row.map((cell, cellIndex) => (
        <TableCell key={cellIndex} text={cell} isTitle={cellIndex === 0} />
      ))}
    </div>
  );
}
